import * as React from 'react';
import { LocalizedText } from 'bernie-l10n';
import { classNames } from 'uitk-react-utils';

export interface StrikeoutPriceProps {
  strikeOut?: string;
  wrapPrice?: boolean;
}

export const StrikeoutPrice: React.FunctionComponent<StrikeoutPriceProps> = ({ strikeOut, wrapPrice }) => {
  const classes = classNames('uitk-cell uitk-type-300 pwa-theme--grey-600 all-l-padding-half', {
    ['all-r-padding-one all-cell-shrink']: !wrapPrice,
    ['m-cell-shrink l-cell-shrink xl-cell-shrink m-r-padding-one l-r-padding-one xl-r-padding-one']: wrapPrice
  });

  return (
    <del className={`${classes}`} data-stid="content-hotel-strikeout-price">
      <span className="is-visually-hidden content-hotel-strikeout-price--text">
        <LocalizedText message="hotels.infosite.rateInfoDialog.strikeOut" data={[strikeOut]} />
      </span>
      <span className="content-hotel-strikeout-price--a11y" aria-hidden="true">
        {strikeOut}
      </span>
    </del>
  );
};
